import { style } from '@vanilla-extract/css';
// import { rootElement } from "../rootElement/Root.css";

export const figcaption = style({
  position: 'relative',
  color: 'inherit',
  textAlign: 'center',
});

export const figcaptionSmall = style({
  fontStyle: 'italic',
});
